import React from 'react'
import PropTypes from 'prop-types'

const JavaScriptBlock = ({ block, manageTags }) => (
  <script type='text/javascript' {...manageTags}>
    {block.value}
  </script>
)

JavaScriptBlock.propTypes = {
  block: PropTypes.object.isRequired,
  manageTags: PropTypes.object
}

export default JavaScriptBlock
